import React from 'react';
import { toast } from 'react-toastify';

/**
 * Detects runtime failures that typically happen after a new deployment
 * (e.g., dynamic import/chunk load errors) and prompts the user to refresh.
 */
export function installUpdateHandlers() {
  if (typeof window === 'undefined') return;

  const showReloadToast = () => {
    // Avoid showing multiple toasts
    if ((window as any).__reload_toast_shown) return;
    (window as any).__reload_toast_shown = true;

    const content = React.createElement(
      'div',
      { style: { display: 'flex', flexDirection: 'column', gap: 8 } },
      React.createElement('strong', null, 'A new version is available'),
      React.createElement(
        'span',
        null,
        'We just deployed an update. Please refresh to continue using the app.'
      ),
      React.createElement(
        'div',
        { style: { display: 'flex', gap: 8, marginTop: 4 } },
        React.createElement(
          'button',
          {
            onClick: () => {
              try {
                toast.dismiss('build-update-available');
              } catch {}
              window.location.reload();
            },
            style: {
              padding: '6px 12px',
              background: '#083147',
              color: '#fff',
              borderRadius: 4,
              border: 'none',
              cursor: 'pointer'
            }
          },
          'Refresh now'
        )
      )
    );

    toast.warn(content as unknown as React.ReactNode, {
      toastId: 'build-update-available',
      autoClose: false,
      closeOnClick: false,
      draggable: false,
      position: 'top-center'
    });
  };

  const errorListener = (event: ErrorEvent) => {
    const msg = String(event?.message || '');
    if (
      msg.includes('ChunkLoadError') ||
      msg.includes('Loading chunk') ||
      msg.includes('Failed to fetch dynamically imported module')
    ) {
      showReloadToast();
    }
  };

  const rejectionListener = (event: PromiseRejectionEvent) => {
    const reason: any = event?.reason;
    const msg = String(reason?.message || reason || '');
    if (
      msg.includes('ChunkLoadError') ||
      msg.includes('Loading chunk') ||
      msg.includes('Failed to fetch dynamically imported module')
    ) {
      showReloadToast();
    }
  };

  // Register listeners once
  if (!(window as any).__update_handlers_installed) {
    window.addEventListener('error', errorListener);
    window.addEventListener('unhandledrejection', rejectionListener);
    (window as any).__update_handlers_installed = true;
  }
}
